import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartConstructorType } from "highcharts-angular";
import { GraphUtils } from "../../../analytics/graphs/utils.service";

@Component({
    selector: 'reporting-participation-details',
    templateUrl: './reporting-participation-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportingParticipationDetailsComponent implements OnChanges {

    protected chartConstructor: ChartConstructorType = 'chart';
    protected chartOptions: Highcharts.Options;

    @Input() chartData: any;

    constructor(
        private translateService: TranslateService,
        private graphUtils: GraphUtils,
    ) {
    }

    ngOnChanges() {
        if(this.chartData) {
            this.chartOptions = this.participationDetailConfig(this.chartData); // Required
        }
    }

    participationDetailConfig (chartData): Highcharts.Options {
        return {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                height: 250,
                backgroundColor: this.graphUtils.graphBackgroundColor,
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: `<b>{point.name}</b>: {point.y} ${ this.translateService.instant('reporting_participation_distrib.people')} <br><i>{point.detail}</i>`
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}<br>({point.prop}%)',
                        distance: -40,
                    },
                    colors: ['#1c7d1c', '#6aa84f', 'lightgrey']
                }
            },
            series: [{
                name: 'Participation frequency',
                data: [
                    {
                        name:  this.translateService.instant('reporting_participation_distrib.regular'),
                        detail:  this.translateService.instant('reporting_participation_distrib.regular_desc'),
                        y: chartData.regular,
                        prop: chartData.regularProp
                    },
                    {
                        name:  this.translateService.instant('reporting_participation_distrib.occasional'),
                        detail:  this.translateService.instant('reporting_participation_distrib.occasional_desc'),
                        y: chartData.occasional,
                        prop: chartData.occasionalProp
                    },
                    {
                        name:  this.translateService.instant('reporting_participation_distrib.no_response'),
                        detail:  this.translateService.instant('reporting_participation_distrib.no_response_desc'),
                        y: chartData.noResponse,
                        prop: chartData.noResponseProp,
                        sliced: true,
                        selected: true
                    }],

            }]
        }
    }
}
